<template>
	<section>
		<h2 class="font-italic">
			<small>Forgot your password?</small>
			Enter your email address.
		</h2>
		<form v-on:submit.prevent="lostPassword">
      <div class="form-group">
          <label for="email" class="sr-only">Email</label>
          <input v-model="email" type="text" class="form-control" :class="{ 'is-invalid': $v.email.$error }"  id="email" placeholder="Email">
          <div class="invalid-feedback" v-if="!$v.email.required">Field is required</div>
          <div class="invalid-feedback" v-if="!$v.email.email">Invalid email format</div>
      </div>
			<div class="row-btn">
				<button type="submit" class="btn btn-primary">Send</button>
			</div>											
		</form>
	</section>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import api from '../http/api.js';
import { required, email  } from 'vuelidate/lib/validators'

export default {
  name: 'LostPassword',
  /*components: {
    HelloWorld
  }*/
  data: function () {
    return {
      email: '',
    }
  },
  validations: {
      email: {
          required,
          email
      },
  },
  methods: {
    lostPassword: function(){
      this.$v.$touch()
      if (this.$v.$invalid) {
          return false;
      }

      const v = this;

      api.post('/v1/lost-password', {
        email: this.email
      })
      .then(() => {
        this.$router.push('/lost-password-confirm')
      }, () => {
          v.$emit('show-message', {
              type: 'danger',
              text: "Oops! Something went wrong!"
          });
      });
    },
  }
}
</script>
